@if (items()?.length === 0) {
<lib-message [type]="isInDialog() ? 'noDataOnBody' : 'noData'">
	@if (design() === 'selectionList') {
	<ng-container>
		@if (noItemsText(); as noItemsText) {
		{{ noItemsText }}
		} @else { There are no items to select from }
	</ng-container>

	} @else {
	<ng-container>
		@if (noItemsText(); as noItemsText) {
		{{ noItemsText }}
		} @else { There are no items }
	</ng-container>
	}
</lib-message>
} @if (items(); as items) { @if (items.length) {

<div class="ui-list" [ngClass]="dialogClassNames()">
	@if (useSearch()) {
	<div class="push-bottom-md">
		<lib-search-input
			[focusOnInit]="isInDialog() ? true : false"
			(search)="handleSearch($event)"
		></lib-search-input>
	</div>
	} @if (displayedItems(); as displayedItems) { @if (displayedItems.length === 0) {
	<lib-message [type]="isInDialog() ? 'noDataOnBody' : 'noData'">
		<ng-container>No items matched your filter</ng-container>
	</lib-message>
	} @if (displayedItems.length) { @for (item of displayedItems; track item.id; let first = $first; let last = $last) {
	<div>
		<ng-template #imagesTemplate>
			<div libFlexRow [libFlexRowGap]="'16px'" [libFlexRowAlign]="isMobileView() ? 'start' : 'center'">
				@for (image of item.filteredImages; track image.originalImage.absoluteUrl; let index = $index) {
				<div libFlexColumn>
					<lib-image
						[alt]="'Image preview'"
						[imageSize]="'50px'"
						[image]="image"
						[isRound]="false"
						[dialogPreviewImage]="image"
					></lib-image>
				</div>
				}
			</div>
		</ng-template>

		<ng-template #itemTemplate>
			<div
				(click)="handleSelectItem(item)"
				class="item"
				[class.link]="item.routerLink"
				[class.pad-top]="true"
				[class.pad-bottom]="true"
				[class.first]="first"
				[class.last]="last"
				[class.active]="selectedItemId() === item.id"
				libFlexRow
				[libFlexRowGap]="'16px'"
			>
				@if (item.videoUrl) {
				<div libFlexColumn [libFlexSize]="'300px'">
					<lib-video [url]="item.videoUrl"></lib-video>
				</div>

				} @if ((item.imagesLocation === 'default' || !item.imagesLocation) && showImages(item)) {
				<div libFlexColumn [libFlexSize]="sizeOfAvatarAndIcon().flex">
					<ng-template [ngTemplateOutlet]="imagesTemplate"></ng-template>
				</div>

				} @if (item.mainIcon) {
				<div libFlexColumn [libFlexSize]="sizeOfAvatarAndIcon().flex">
					<div libFlexRow [libFlexRowAlign]="'center'">
						<div libFlexColumn>
							<lib-icon [type]="item.mainIcon"></lib-icon>
						</div>
					</div>
				</div>

				} @if (item.mainAvatar || showNameBasedAvatar()) {
				<div libFlexColumn [libFlexSize]="sizeOfAvatarAndIcon().flex">
					<lib-image
						[alt]="'List item avatar'"
						[maxHeight]="sizeOfAvatarAndIcon().widthAndHeight"
						[maxWidth]="sizeOfAvatarAndIcon().widthAndHeight"
						[imageSize]="'50px'"
						[image]="item.avatar"
						[avatarName]="showNameBasedAvatar() ? item.title : undefined"
					></lib-image>
				</div>
				}
				<div libFlexColumn libFlexFill>
					<div>
						<div libFlexRow [libFlexRowGap]="'8px'">
							<div libFlexColumn libFlexFill>
								<span libText1 libLineClamp class="title" [clampLines]="2">
									{{ item.title }}
								</span>
							</div>
							@if (item.fromNowDate) {
							<div libFlexColumn libText5>
								{{ fromNow(item.fromNowDate, 'narrow') }}
							</div>
							}
						</div>

						@if (item.subtitle) {
						<div libText3 libLineClamp [clampLines]="2" class="subtitle">
							{{ item.subtitle }}
						</div>
						} @if (item.tag && calculatedTagLocation() === 'inline') {
						<div class="push-top-xs">
							<lib-tag [tagType]="'basic'">{{ item.tag }}</lib-tag>
						</div>
						}
					</div>
				</div>
				@if (item.pieGraph) {
				<div libFlexColumn>
					<lib-pie-chart
						[view]="[40, 40]"
						[showLabels]="false"
						[singleSeries]="item.pieGraph.singleSeries"
						[colorScheme]="item.pieGraph.colorScheme"
					></lib-pie-chart>
				</div>
				} @if (item.tag && !isMobileView() && calculatedTagLocation() === 'end') {
				<div libFlexColumn>
					<lib-tag [tagType]="'basic'">{{ item.tag }}</lib-tag>
				</div>
				} @if ((item.imagesLocation === 'end' || !item.imagesLocation) && showImages(item)) {
				<div libFlexColumn>
					<ng-template [ngTemplateOutlet]="imagesTemplate"></ng-template>
				</div>
				} @if (item.buttons && item.buttons.length) {
				<div libFlexColumn>
					<lib-button-list [mode]="'single'" [buttons]="item.buttons"></lib-button-list>
				</div>
				} @if (item.selectIcon) {
				<div libFlexColumn [libFlexSize]="sizeOfAvatarAndIcon().flex">
					<lib-icon [type]="item.selectIcon"></lib-icon>
				</div>
				}
			</div>
		</ng-template>

		<lib-link [externalUrl]="item.externalUrlLink" [routerLink]="item.routerLink" [linkStyle]="'noUnderline'">
			<ng-template [ngTemplateOutlet]="itemTemplate"></ng-template>
			@if (!last && showDivider()) {
			<lib-divider [mode]="'dotted'"></lib-divider>
			} @else {
			<div class="push-top-xs"></div>
			}
		</lib-link>
	</div>
	} } @if (showLoadMore() === true) {
	<div class="push-top-md" libFlexRow [libFlexRowAlign]="'center'">
		<div libFlexColumn>
			<lib-button [buttonType]="'basic'" (click)="handleLoadMore()">
				<span>
					Show more @if (showLoadMoreCount(); as count) {
					<span>(+{{ count }})</span>
					}
				</span>
			</lib-button>
		</div>
	</div>
	} }
</div>

} }
